<template>
  <portal to="modal">
    <transition name="bar-map-fade">
      <div class="bar-map" v-if="this.$store.state.main.barMapActive">
        <div class="bar-map-container">
          <div class="close-wrapper">
            <h2 class="f-34">{{$fn.tr('ჩამოსასხმელი ჟუჟუნა')}}</h2>

            <div class="close-btn pointer" @click="openBarMap()">
              <svg
                xmlns="http://www.w3.org/2000/svg"
                width="26.469"
                height="27.766"
                viewBox="0 0 26.469 27.766"
              >
                <g
                  id="Group_240"
                  data-name="Group 240"
                  transform="translate(-1721.922 -107.326)"
                >
                  <path
                    id="Path_1643"
                    data-name="Path 1643"
                    d="M1.327,4.6c5.967.11,11.824-1.074,17.777-1.2,3.641-.077,7.6.437,11.16-.633.884-.266,1.97-.777,1.935-1.837l0-.129C32.16-.223,30.251-.187,28.922.468c-3.236.742-6.913.076-10.173.249C13.5,1,8.309,1.961,3.043,1.863,1.23,1.831-1.742,4.544,1.327,4.6Z"
                    transform="translate(1725.181 107.326) rotate(45)"
                    fill="#101820"
                  />
                  <path
                    id="Path_1644"
                    data-name="Path 1644"
                    d="M29.1.291c-3.635,1.787-8.026,1.644-11.979,1.44A123.652,123.652,0,0,1,3.008.37C.8,0-1.6,3.126,1.433,3.635A110.5,110.5,0,0,0,18.464,5.1c4.3.045,8.71-.245,12.631-2.173C33.875,1.564,31.384-.833,29.1.291Z"
                    transform="translate(1721.922 131.48) rotate(-45)"
                    fill="#101820"
                  />
                </g>
              </svg>

              <span class="f-21 regular">
                {{$fn.tr('დახურვა')}}
              </span>
            </div>
          </div>
          <div class="inner">
                <el-select v-model="value" :placeholder="$fn.tr('აირჩიეთ ქალაქი')">
                <el-option
               
                v-for="item in cityCenters"
                :key="item.id"
                :label="item.title"
                :value="item.title"
                 
                
                >
                </el-option>
            </el-select>
            <GmapMap
              :center="center"
              :zoom="12"
              map-type-id="roadmap"
              
              :options="{
                  
                zoomControl: true,
                mapTypeControl: false,
                scaleControl: false,
                streetViewControl: false,
                rotateControl: false,
                fullscreenControl: false,
                disableDefaultUi: true,
                styles: mapStyle, 
                }"
            >
            <gmap-info-window class="juju-map-info"
				v-for="(i, index) in _.get(contentData, 'data.list')"
                :key="index + 'A'"
		        :position="setPosition(i.map[0])"
		        :opened="info == index"> 
                <div class="juju-map-tooltip">
                    <span class="bold-italic f-16">{{ i.title }}</span>
                    <span class="light-italic f-14">{{ i.city }}</span>
                    <span class="light-italic f-14">{{ i.address }}</span>
         
                    <a :href="'http://maps.google.com/maps?q=loc:' + parseFloat(i.map[0].lat) + ',' + parseFloat(i.map[0].long)" target="_blank" class="btn"><span class="bold-italic f-14">{{$fn.tr('Get Directions')}}</span></a>
                </div>
                
      </gmap-info-window>
              <GmapMarker
                :key="index"
                v-for="(m, index) in _.get(contentData, 'data.list')"
                 :position="setPosition(m.map[0])"
                :icon="m.Icon[0] ? m.Icon[0].url : '@/assets/img/jujupin.png'"
                :clickable="true"
                :draggable="false"
                @click="toggleActive(index)"
              />
            </GmapMap>
          </div>
        </div>
      </div>
    </transition>
  </portal>
</template>

<script>
import * as VueGoogleMaps from "vue2-google-maps";
import Vue from "vue";
Vue.use(VueGoogleMaps, {
  load: {
    key: "AIzaSyCafS1FUd644OyagUCmyo_HCqAwYAOsIPI",
    libraries: "places"
  }
});
export default {
  props: ['contentData'],
  data() {
    return {
        value: '',
        info: null,
        center: {
            lat: 41.69784921001205, 
            lng: 44.80395176348713 
        },
        mapStyle:[
				  {
				    "elementType": "geometry",
				    "stylers": [
				      {
				        "color": "#f5f5f5"
				      }
				    ]
				  },
				  {
				    "elementType": "labels.icon",
				    "stylers": [
				      {
				        "visibility": "off"
				      }
				    ]
				  },
				  {
				    "elementType": "labels.text.fill",
				    "stylers": [
				      {
				        "color": "#616161"
				      }
				    ]
				  },
				  {
				    "elementType": "labels.text.stroke",
				    "stylers": [
				      {
				        "color": "#f5f5f5"
				      }
				    ]
				  },
				  {
				    "featureType": "administrative.country",
				    "elementType": "geometry.stroke",
				    "stylers": [
				      {
				        "color": "#BACB32"
				      },
				      {
				        "weight": 2.5
				      }
				    ]
				  },
				  {
				    "featureType": "administrative.land_parcel",
				    "elementType": "labels.text.fill",
				    "stylers": [
				      {
				        "color": "#bdbdbd"
				      }
				    ]
				  },
				  {
				    "featureType": "poi",
				    "elementType": "geometry",
				    "stylers": [
				      {
				        "color": "#eeeeee"
				      }
				    ]
				  },
				  {
				    "featureType": "poi",
				    "elementType": "labels.text.fill",
				    "stylers": [
				      {
				        "color": "#757575"
				      }
				    ]
				  },
				  {
				    "featureType": "poi.park",
				    "elementType": "geometry",
				    "stylers": [
				      {
				        "color": "#e5e5e5"
				      }
				    ]
				  },
				  {
				    "featureType": "poi.park",
				    "elementType": "labels.text.fill",
				    "stylers": [
				      {
				        "color": "#9e9e9e"
				      }
				    ]
				  },
				  {
				    "featureType": "road",
				    "elementType": "geometry",
				    "stylers": [
				      {
				        "color": "#ffffff"
				      }
				    ]
				  },
				  {
				    "featureType": "road.arterial",
				    "elementType": "labels.text.fill",
				    "stylers": [
				      {
				        "color": "#757575"
				      }
				    ]
				  },
				  {
				    "featureType": "road.highway",
				    "elementType": "geometry",
				    "stylers": [
				      {
				        "color": "#dadada"
				      }
				    ]
				  },
				  {
				    "featureType": "road.highway",
				    "elementType": "labels.text.fill",
				    "stylers": [
				      {
				        "color": "#616161"
				      }
				    ]
				  },
				  {
				    "featureType": "road.local",
				    "elementType": "labels.text.fill",
				    "stylers": [
				      {
				        "color": "#9e9e9e"
				      }
				    ]
				  },
				  {
				    "featureType": "transit.line",
				    "elementType": "geometry",
				    "stylers": [
				      {
				        "color": "#e5e5e5"
				      }
				    ]
				  },
				  {
				    "featureType": "transit.station",
				    "elementType": "geometry",
				    "stylers": [
				      {
				        "color": "#eeeeee"
				      }
				    ]
				  },
				  {
				    "featureType": "water",
				    "elementType": "geometry",
				    "stylers": [
				      {
				        "color": "#c9c9c9"
				      }
				    ]
				  },
				  {
				    "featureType": "water",
				    "elementType": "labels.text.fill",
				    "stylers": [
				      {
				        "color": "#9e9e9e"
				      }
				    ]
				  }
				],
    };
  },

  computed: {
    cityCenters(){
      return this.$store.state.main.indx.terms.cities;
    }
  },
  watch: {
      value(newVal, oldVal){
          //console.log(newVal + oldVal)
         let cities = this.cityCenters;
        let selected = cities.filter(city =>
          city.title.includes(newVal)
        );
              this.center.lat = parseFloat(selected[0].lat);
                this.center.lng = parseFloat(selected[0].long);     
      
      }
  },
  mounted() {
    console.log(_.get(this.contentData, 'data.list'))
  },
  methods: {
   
      	toggleActive(index){
			

				if(this.info != index){
					this.info = index;
				}else{
					this.info = null;
				}
			},
      	setPosition(m){
				let position = {
			    	lat: parseFloat(m.lat), 
			    	lng: parseFloat(m.long)
			    };
			    return position;
			},
    openBarMap() {
      this.$store.commit(
        "main/barMapStatus",
        !this.$store.state.main.barMapActive
      );
    }
  }
};
</script>

<style lang="scss">
.bar-map .el-select{
    position: absolute;
    top: 21px;
    left: 21px;
    z-index: 9999;
}
.el-popper[x-placement^=bottom] .popper__arrow{
   display: none;
}
.el-popper[x-placement^=bottom]{
    margin-top: 10px;
}
.el-select-dropdown{
    border: none;
      background-color: #044B30;
      box-shadow: none;
      border-radius: 0;
}
.el-select-dropdown__item{
      background-color: #044B30;
    span{
          font-family: "FiraGO-BoldItalic";
    font-size: 16px;
    color: white;
  
    }
    
    &:hover, &.hover{
       background-color: #044B30;
    }
}

.el-input__inner{
   &::placeholder{
        color: white !important;
    }
    font-family: "FiraGO-BoldItalic";
    font-size: 16px;
    color: white;
    background-color: #044B30;
    border-radius: 0;
    border: none;
    outline: none;
    padding: 0 21px;
    width: 299px;
    height: 50px;
    z-index: 9999;
}
  .el-select-dropdown{
      z-index: 9999 !important;;

  }
     .gm-style .gm-style-cc a, .gm-style .gm-style-cc button, .gm-style .gm-style-cc span, .gm-style .gm-style-mtc div{
         display: none;
     }   
	.gm-style .gm-style-iw-d{
		overflow: visible !important;
	}
	.gm-style .gm-style-iw-t::after{
		//display: none;
        top: -80px;
        box-shadow: none;
        background:#BACB32;
	}
.gm-style .gm-style-iw > button{
		display: none !important;
	}
.gm-style .gm-style-iw-c{
    	top: -80px;
		left: 0px;
    padding: 0;
    box-shadow: none;
    border-radius: 0;
    background-color: transparent;
    border: none;
}
  .juju-map-tooltip{
      height: 147px;
      width: 192px;
      background-color: #BACB32;
      padding: 21px 13px 13px 13px;
      display: flex;
      flex-direction: column;
      .btn{
          background: white;
          display: flex;
          justify-content: center;
          align-items: center;
          margin-left: auto;
          margin-right: auto;
          width: 150px;
          height: 42px;
          margin-top: 13px;
          cursor: pointer;
          span{
               &:nth-child(1){
              margin-bottom: 0;
          }
          }

      }
      span{
          color:#044B30;
          &:nth-child(1){
              margin-bottom: 6px;
          }

      }
  }
.bar-map {
  position: fixed;
  width: 100%;
  height: 100%;
  background-color: rgba(16, 24, 32, 0.8);
  z-index: 9998;

 
 
  &-container {
    position: absolute;
    display: flex;
    flex-direction: column;
    top: 50%;
    left: 50%;
    background-color: white;
    padding: 30px;
    transform: translate(-50%, -50%);
    width: 1110px;
    height: 610px;

    .inner {
      position: relative;
      border: #044b30 3px solid;
      width: 100%;
      height: 479px;
    }
    .vue-map-container {
      width: 100%;
      height: 100%;
    }
  }
  .close-wrapper {
    display: flex;
    justify-content: space-between;
    align-items: center;
    margin-bottom: 30px;
    width: 100%;
    h2 {
      color: #044b30;
    }
  }
  .close-btn {
    display: flex;
    align-items: center;
    cursor: pointer;
    transition: 0.4s;
    will-change: transform;
    @media (min-width: 1024px) {
      &:hover {
        transform: scale(1.1) rotate(-2deg);
      }
    }
    svg {
      margin-right: 9.6px;
    }
  }
 
  @media (max-width: 1365px){
    
    .bar-map-container{
          width: 900px;
            padding: 20px;
      }
  }

  
  @media (max-width: 1023px){
    .bar-map-container{
          width: 650px;
          .inner{
              height: 500px;
          }
      }
  }


  @media (max-width: 767px){
      .close-wrapper{
          h2{
              font-size: 21px;
          }
      }
    .bar-map-container{
          width: 100%;
          height: 100%;
          .inner{
              height: 100%;
          }
      }
  }

  @media (max-width: 413px){
    .close-wrapper h2{
      font-size: 16px;
    }
    .el-select{
      left: 5px;
    }
    .el-input__inner{
      width: 250px !important;
    }
    .close-btn{
      span{
        display: none;
      }
    }
  }


}


.bar-map-fade-enter-active,
.bar-map-fade-leave-active {
  transition: opacity 0.5s;
}
.bar-map-fade-enter,
.bar-map-fade-leave-to {
  opacity: 0;
}
</style>
